import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { AwardIcon, ClockIcon, UsersIcon, LockIcon } from 'lucide-react';
export function CredibilitySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-bg py-20 md:py-28" data-id="element-57">
      <div className="max-w-4xl mx-auto px-6" data-id="element-58">
        <motion.h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-white text-center mb-6 tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          WHY <span className="text-orange-accent" data-id="element-60">TRUST</span> THIS GUIDE?
        </motion.h2>

        <motion.p className="font-inter text-lg text-concrete text-center max-w-2xl mx-auto mb-12 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-61">
          This isn't theory from someone who read a few articles online. These
          are battle-tested methods from professionals who've spent decades
          protecting high-value assets.
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12" data-id="element-62">
          <motion.div className="text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-63">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30" data-id="element-64">
              <ClockIcon className="w-8 h-8 text-orange-accent" data-id="element-65" />
            </div>
            <div className="font-bebas text-3xl text-white" data-id="element-66">25+</div>
            <div className="font-inter text-sm text-concrete" data-id="element-67">
              Years Experience
            </div>
          </motion.div>

          <motion.div className="text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-68">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30" data-id="element-69">
              <UsersIcon className="w-8 h-8 text-orange-accent" data-id="element-70" />
            </div>
            <div className="font-bebas text-3xl text-white" data-id="element-71">2,847</div>
            <div className="font-inter text-sm text-concrete" data-id="element-72">Vaults Built</div>
          </motion.div>

          <motion.div className="text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-73">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30" data-id="element-74">
              <LockIcon className="w-8 h-8 text-orange-accent" data-id="element-75" />
            </div>
            <div className="font-bebas text-3xl text-white" data-id="element-76">0</div>
            <div className="font-inter text-sm text-concrete" data-id="element-77">
              Breaches Reported
            </div>
          </motion.div>

          <motion.div className="text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-78">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-orange-accent/10 border border-orange-accent/30" data-id="element-79">
              <AwardIcon className="w-8 h-8 text-orange-accent" data-id="element-80" />
            </div>
            <div className="font-bebas text-3xl text-white" data-id="element-81">TIER 1</div>
            <div className="font-inter text-sm text-concrete" data-id="element-82">
              Contractor Methods
            </div>
          </motion.div>
        </div>

        <motion.div className="bg-dark-card border border-white/5 p-6 md:p-8" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-83">
          <p className="font-inter text-concrete leading-relaxed mb-4" data-id="element-84">
            <span className="text-white font-semibold" data-id="element-85">
              "The techniques in this guide come from the same playbook used by
              high-net-worth individuals, collectors, and professionals who
              can't afford to have their assets discovered.
            </span>
          </p>
          <p className="font-inter text-concrete leading-relaxed" data-id="element-86">
            We've adapted these methods for the everyday homeowner — using
            materials you can buy at any hardware store, with skills anyone can
            learn in a weekend. No contractors. No permits. No paper trail."
          </p>
          <p className="font-inter text-orange-accent font-semibold mt-4" data-id="element-87">
            — The Concrete Bunker Team
          </p>
        </motion.div>
      </div>
    </section>;
}